import { queryOptions } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost } from '../utils/api';

export const conversationHistoryKey = (prospectId) => ['/conversation-history', prospectId || ''];

export const getConversationHistory = (prospectId) =>
  queryOptions({
    queryKey: conversationHistoryKey(prospectId),
    queryFn: async () => {
      const res = await axiosGet('/conversation-history', { params: { prospectId } });
      return res.data;
    },
    enabled: Boolean(prospectId),
    staleTime: 0,
    refetchOnMount: 'always',
    retry: 1,
  });

export const reconcileConversationHistory = (payload) => axiosPost('/conversation-history/reconcile', payload);

export const clearConversationHistory = (prospectId) =>
  axiosDelete('/conversation-history', { params: { prospectId } });

export const writeEngageMessage = (payload) => axiosPost('/conversation-history/write', payload);

export const confirmOutboundMessage = (payload) => axiosPost('/conversation-history/confirm', payload);
